module.exports = __webpack_public_path__ + "static/media/hospital-alt.3afdc623.svg";